import React from "react";
import { Modal, Typography, Col, Input, Button } from "antd";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import { InputText } from "../../../shared/components";
import { ListAutoComplet } from "../style";
import MapContainer from "./map";
import { useCreateWarehouse, useWarehouse } from "../../warehouses";

const { Title, Text } = Typography;

export const ModalDirecciones = ({
  geo,
  setGeo,
  openModalCreate,
  openModalEdit,
  setOpenModalCreate,
  setOpenModalEdit,
  warehouseId,
}: {
  setGeo: any;
  geo: { latitude: number; longitude: number };
  openModalEdit: boolean;
  openModalCreate: boolean;
  setOpenModalCreate: (val: boolean) => void;
  setOpenModalEdit: (val: boolean) => void;
  warehouseId: number
}) => {
  const {
    handleSubmit,
    control: controlWarehouse,
    watch: watchWarehouseName,
    setValue,
  } = useCreateWarehouse({ setOpenModalCreate: setOpenModalCreate });
  const name = watchWarehouseName("name");
  const [address, setAddress] = React.useState<string>("");
  const {warehouseInfo, warehouseById} = useWarehouse({warehouseId})
 
const handleChange = (address: string) => {
    setAddress(address);
  };

  const handleSelect = (address: string) => {
    geocodeByAddress(address)
      .then((results) => {
        setAddress(results[0].formatted_address.split(",")[0]);
        return getLatLng(results[0]);
      })
      .then((latLng) => {
        setGeo({ latitude: latLng.lat, longitude: latLng.lng });
      })
      .catch((error) => console.error("Error", error));
  };

  React.useEffect(() => {
    if (openModalCreate) {
      setAddress("");
      setGeo({ latitude: 0, longitude: 0 });
    }

    if (openModalEdit && warehouseId) {
      warehouseById();

      if (warehouseInfo) {
        setAddress(warehouseInfo.address);
        setGeo({ latitude: warehouseInfo.latitude, longitude: warehouseInfo.longitude });
        setValue("name", warehouseInfo.name);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModalCreate, openModalEdit, warehouseId, warehouseInfo]);


  return (
    <Modal
    className="container-modal"
    centered
    open={openModalCreate || openModalEdit} // Abre el modal si cualquiera de los dos valores es verdadero
    title={
      openModalCreate ? "Agrega una dirección" : "Actualizar una dirección"
    }
    width={650}
    onCancel={() => {
      if (openModalCreate) {
        setOpenModalCreate(false);
      } else {
        setOpenModalEdit(false);
      }
    }}
    footer={null}
  >
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <div style={{ display: "flex", flexDirection: "row", gap: "16px" }}>
          <div style={{ flex: 1 }}>
            {geo.latitude !== 0 ? (
              <MapContainer
                coord={{ lat: geo.latitude, lng: geo.longitude }}
                setAddress={setAddress}
                setGeo={setGeo}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  backgroundColor: "#f0f2f5",
                  borderRadius: "8px",
                  textAlign: "center",
                }}
              >
                <Title
                  level={4}
                  style={{ color: "#E95735", margin: 0, padding: 3 }}
                >
                  Escribe la dirección que deseas buscar
                </Title>
              </div>
            )}
          </div>
          <div style={{ flex: 1, height: 250 }}>
            <Col
              span={24}
              style={{
                display: "flex",
                marginBottom: "10px",
                justifyContent: "center",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <Text style={{ marginBottom: "1px" }}>Nombre:</Text>
              <InputText
                name="name"
                placeHolder="Nombre bodega"
                control={controlWarehouse}
              />
            </Col>
            <PlacesAutocomplete
              searchOptions={{
                location: new window.google.maps.LatLng(11.004107, -74.806984),
                radius: 50000,
                componentRestrictions: { country: "co" },
              }}
              value={address}
              onChange={handleChange}
              onSelect={handleSelect}
            >
              {({
                getInputProps,
                suggestions,
                getSuggestionItemProps,
                loading,
              }) => (
                <div style={{ position: "relative" }}>
                  <Text style={{ marginBottom: "1.5px" }}>Dirección:</Text>
                  <Input
                    {...getInputProps({
                      placeholder: "Buscar dirección",
                      className: "location-search-input",
                    })}
                  />
                  <div className="autocomplete-dropdown-container">
                    {loading && <div>Loading...</div>}
                    {suggestions.map((suggestion, index) => (
                      <ListAutoComplet
                        className="items"
                        {...getSuggestionItemProps(suggestion)}
                        key={index}
                      >
                        <div
                          className="items_address"
                          style={{ background: "white" }}
                        >
                          <div>
                            <p
                              style={{
                                cursor: "pointer",
                                fontWeight: "bold",
                                margin: 0,
                              }}
                            >
                              {suggestion.formattedSuggestion.mainText}
                            </p>
                            <p style={{ cursor: "pointer" }}>
                              {suggestion.formattedSuggestion.secondaryText}
                            </p>
                          </div>
                          <span>{`>`}</span>
                        </div>
                      </ListAutoComplet>
                    ))}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>
            <div style={{width: '100%', textAlign: 'end'}}>
            <Button
              style={{
                marginTop: 20,
                background: "#E95735",
                borderRadius: 15,
                color: "white",
                fontWeight: "bold",
              }}
              onClick={() =>
                handleSubmit(name, address, geo.latitude, geo.longitude)
              }
            >
              Enviar
            </Button>

            </div>
          </div>
        </div>
      </div>
  </Modal>
  
  );
};
